"use strict";

require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'diamondDetail',
  components: {},
  props: {
    detail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activeStep: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      previewVisible: false,
      // 控制大图弹窗显示
      previewList: [],
      // 当前图片组
      previewIndex: 0 // 当前图片索引
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    previewImg: function previewImg(url) {
      // 找到当前点击图片所在的图片组
      // 由于 v-for="imgUrl in item.appealUrl.split(',')"，所以 appealUrl.split(',') 就是图片组
      // 需要找到当前 item
      var group = [];
      var idx = 0;
      // 遍历 reviewList 找到包含当前图片的那一项
      var _iterator = _createForOfIteratorHelper(this.detail.reviewList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var step = _step.value;
          if (step.appealUrl && step.appealUrl.includes(url)) {
            group = step.appealUrl.split(',');
            idx = group.indexOf(url);
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.previewList = group;
      this.previewIndex = idx;
      this.previewVisible = true;
    },
    prevImg: function prevImg() {
      if (this.previewIndex > 0) {
        this.previewIndex--;
      }
    },
    nextImg: function nextImg() {
      if (this.previewIndex < this.previewList.length - 1) {
        this.previewIndex++;
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    }
  },
  mounted: function mounted() {}
};